import { fetchRest } from "../../common/utils/fetchRest";

export const login = async (email: string, password: string): Promise<any> => {
  const endpoint = "/auth/login";

  return fetchRest(endpoint, "POST", { email, password });
};
